import { render, staticRenderFns } from "./CategoricalCeterisParibus.vue?vue&type=template&id=290b938a&"
import script from "./CategoricalCeterisParibus.vue?vue&type=script&lang=js&"
export * from "./CategoricalCeterisParibus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports